import gql from 'graphql-tag'

const GET_EMAIL_ADDRESS_USAGE_COUNT = gql`
  query GetEmailAddressUsageCount($emailAddress: String!, $ignoreIds: [ID!]) {
    getEmailAddressUsageCount(email: $emailAddress, ignoreIds: $ignoreIds)
  }
`

export { GET_EMAIL_ADDRESS_USAGE_COUNT }
